export default "__VITE_ASSET__0db2f87b__"